import { LocalShoppingItemsData } from './providers/local-shopping-items-data';
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler} from 'ionic-angular';
import { PageRef } from '../../core/core.module';
import { TextMaskModule } from 'angular2-text-mask';

import { AccountPage } from './pages/account/account';
import { AccountPageFull } from './pages/account/account.full';
import { AccountCommon } from './pages/account/account.common';

import { ForgotPasswordPage } from './pages/forgot-password/forgot-password';
import { ForgotPasswordPageFull } from './pages/forgot-password/forgot-password.full';
import { ForgotPasswordCommon } from './pages/forgot-password/forgot-password.common';

import { LoginPage } from './pages/login/login';
import { LoginPageFull } from './pages/login/login.full';
import { LoginCommon } from './pages/login/login.common';

import { SignupPage } from './pages/signup/signup';
import { SignupPageFull } from './pages/signup/signup.full';
import { SignupCommon } from './pages/signup/signup.common';

import { ProfilePage } from './pages/profile/profile';
import { ProfilePageFull } from './pages/profile/profile.full';
import { ProfileCommon } from './pages/profile/profile.common';

import { ShoppingListPage } from './pages/shopping-list/shopping-list';
import { ShoppingListPageFull } from './pages/shopping-list/shopping-list.full';
import { ShoppingListCommon } from './pages/shopping-list/shopping-list.common';

import { OrderHistoryPage } from './pages/order-history/order-history';
import { OrderHistoryPageFull } from './pages/order-history/order-history.full';
import { OrderHistoryCommon } from './pages/order-history/order-history.common';

import { AccountData }from'./providers/account-data';

import { ShoppingListData }from'./providers/shopping-list-data';


//Export
export { AccountPage } from './pages/account/account';
export { AccountPageFull } from './pages/account/account.full';

export { ForgotPasswordPage } from './pages/forgot-password/forgot-password';
export { ForgotPasswordPageFull } from './pages/forgot-password/forgot-password.full';

export { LoginPage } from './pages/login/login';
export { LoginPageFull } from './pages/login/login.full';

export { SignupPage } from './pages/signup/signup';
export { SignupPageFull } from './pages/signup/signup.full';

export { ProfilePage } from './pages/profile/profile';
export { ProfilePageFull } from './pages/profile/profile.full';

export { ShoppingListPage } from './pages/shopping-list/shopping-list';
export { ShoppingListPageFull } from './pages/shopping-list/shopping-list.full';

export { OrderHistoryPage } from './pages/order-history/order-history';
export { OrderHistoryPageFull } from './pages/order-history/order-history.full';


@NgModule({
    imports: [
        IonicModule,
        TextMaskModule
    ],
    declarations: [
        AccountPage,
        AccountPageFull,
        ForgotPasswordPage,
        ForgotPasswordPageFull,
        LoginPage,
        LoginPageFull,
        SignupPage,
        SignupPageFull,
        ProfilePage,
        ProfilePageFull,
        ShoppingListPage,
        ShoppingListPageFull,
        OrderHistoryPage,
        OrderHistoryPageFull,
    ],
    exports: [
        AccountPage,
        AccountPageFull,
        ForgotPasswordPage,
        ForgotPasswordPageFull,
        LoginPage,
        LoginPageFull,
        SignupPage,
        SignupPageFull,
        ProfilePage,
        ProfilePageFull,
        ShoppingListPage,
        ShoppingListPageFull,
        OrderHistoryPage,
        OrderHistoryPageFull,
    ],
    bootstrap: [],
    entryComponents: [
        AccountPage,
        AccountPageFull,
        ForgotPasswordPage,
        ForgotPasswordPageFull,
        LoginPage,
        LoginPageFull,
        SignupPage,
        SignupPageFull,
        ProfilePage,
        ProfilePageFull,
        ShoppingListPage,
        ShoppingListPageFull,
        OrderHistoryPage,
        OrderHistoryPageFull,
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler},AccountData, ShoppingListData, LocalShoppingItemsData, AccountCommon, ForgotPasswordCommon, LoginCommon, ProfileCommon, ShoppingListCommon, OrderHistoryCommon, SignupCommon]
})
export class AccountModule{

    constructor(
        public pageRef: PageRef
    ){
        let linksCfg = [
            { component: AccountPage, fullComponent:AccountPageFull, name: 'Acccount Page', segment: 'account' },
            { component: ForgotPasswordPage, fullComponent: ForgotPasswordPageFull, name: 'Forgot Password', segment: 'forgot-password' },
            { component: ShoppingListPage, fullComponent: ShoppingListPageFull, name: 'Shopping List', segment: 'shopping-list' },
            { component: OrderHistoryPage, fullComponent: OrderHistoryPageFull, name: 'Order History', segment: 'order-history' },
            { component: LoginPage, fullComponent: LoginPageFull, name: 'Login', segment: 'login' },
            { component: SignupPage, fullComponent: SignupPageFull, name: 'Sign Up', segment: 'signup' },
            { component: ProfilePage, fullComponent: ProfilePageFull, name: 'Profile', segment: 'profile' }
        ];
        this.pageRef.addCfgLinks(linksCfg); 
    }
}


// WEBPACK FOOTER //
// ./src/modules/account/account.module.ts